import { cn } from '../../utils'

type VerticalDividerProps = {
  variant: 'vertical'
  height: string
  className?: string
  color?: 'blue' | 'grey'
}

type HorizontalDividerProps = {
  variant: 'horizontal'
  width: string
  className?: string
  glowPosition?: 'left' | 'center' // default: center
  color?: 'blue' | 'grey'
}

type GradientDividerProps =
  | (Omit<VerticalDividerProps, 'variant'> & { variant?: 'vertical'; color?: 'blue' | 'grey' })
  | (HorizontalDividerProps & { color?: 'blue' | 'grey' })

export const GradientDivider = (props: GradientDividerProps) => {
  const isVertical = props.variant !== 'horizontal'
  const glowPosition = !isVertical && 'glowPosition' in props ? props.glowPosition : 'center'
  const color = 'color' in props && props.color === 'grey' ? 'grey' : 'blue'

  let horizontalGradient = ''
  let verticalGradient = ''

  if (color === 'grey') {
    horizontalGradient =
      glowPosition === 'left'
        ? 'bg-[linear-gradient(90deg,rgba(110,153,194,0)_0%,rgba(96,97,98,1)_10%,rgba(110,153,194,0)_100%)]'
        : 'from-[#6E99C200] via-[#606162] to-[#6E99C200] bg-linear-to-r'

    verticalGradient = 'from-[#6E99C200] via-[#606162] to-[#6E99C200]'
  } else {
    horizontalGradient =
      glowPosition === 'left'
        ? 'bg-[linear-gradient(90deg,rgba(110,153,194,0)_0%,rgba(145,179,240,1)_10%,rgba(110,153,194,0)_100%)]'
        : 'from-[#6E99C200] via-[#91B3F0] to-[#6E99C200] bg-linear-to-r'

    verticalGradient = 'from-[#6E99C200] via-[#91B3F0] to-[#6E99C200]'
  }

  return (
    <div
      className={cn(
        {
          // Horizontal
          'h-px': !isVertical,
          [!isVertical && 'width' in props ? props.width : '']: !isVertical,
          // Vertical
          'w-px bg-linear-to-b': isVertical,
          [isVertical ? (props as VerticalDividerProps).height : '']: isVertical,
        },
        !isVertical ? horizontalGradient : verticalGradient,
        props.className,
      )}
    />
  )
}
